module.exports = __webpack_public_path__ + "static/media/critical-role.94fad123.svg";